export default [
  {
    path: "/",
    name: "layout",
    component: () => import("@/layouts/AppLayout"),
    children: [
      {
        path: "/",
        name: "onBoarding",
        query: "index",
        component: () => import("@/pages/OnBoarding.vue"),
        meta: {
          auth: false,
          topMenu: {
            left: [],
            right: ["cross"]
          }
        }
      },
      {
        path: "/greeting",
        name: "greeting",
        component: () => import("@/pages/Greeting.vue"),
        meta: {
          auth: false,
          topMenu: {
            left: [],
            right: ["cross"]
          }
        }
      },
      {
        path: "/search",
        name: "offerSearch",
        component: () => import("@/pages/Offers.vue"),
        meta: {
          auth: false,
          topMenu: {
            left: ["back"],
            right: ["hamburger", "notification"]
          }
        }
      },
      {
        path: "offer-details/:id",
        name: "offerDetails",
        component: () => import("@/pages/OfferDetails"),
        meta: {
          auth: true,
          topMenu: {
            left: ["back"],
            right: ["heart"]
          }
        }
      },
      {
        path: "favorite-offers",
        name: "favoriteOffers",
        component: () => import("@/pages/Favorites"),
        meta: {
          auth: true,
          topMenu: {
            left: ["back"],
            right: ["hamburger", "notification"]
          }
        }
      },
      {
        path: "check-lastname",
        name: "checkLastname",
        component: () => import("@/pages/signup/checkLastname"),
        meta: {
          auth: false,
          topMenu: {
            left: [],
            right: ["cross"]
          }
        }
      },
      {
        path: "check-lastname-failed",
        name: "checkLastnameFailed",
        component: () => import("@/pages/signup/checkLastnameFailed"),
        meta: {
          auth: false,
          topMenu: {
            left: [],
            right: ["cross"]
          }
        }
      },
      {
        path: "confirm-cell",
        name: "confirmCell",
        component: () => import("@/pages/signup/ConfirmCellPhone"),
        meta: {
          auth: false,
          topMenu: {
            left: [],
            right: ["cross"]
          }
        }
      },
      {
        path: "confirm-otp",
        name: "confirmOtp",
        component: () => import("@/pages/signup/ConfirmOtp"),
        meta: {
          auth: false,
          topMenu: {
            left: [],
            right: ["cross"]
          }
        }
      },
      {
        path: "accept-contract",
        name: "acceptContract",
        component: () => import("@/pages/signup/AcceptContract"),
        meta: {
          auth: false,
          topMenu: {
            left: [],
            right: ["cross"]
          }
        }
      },
      {
        path: "profile",
        name: "ProfileLanding",
        component: () => import("@/pages/profile/Landing"),
        meta: {
          auth: true,
          topMenu: {
            left: ["back"],
            right: []
          }
        }
      },
      {
        path: "profile/edit",
        name: "ProfileEdit",
        component: () => import("@/pages/profile/ProfileEdit"),
        meta: {
          auth: true,
          topMenu: {
            left: ["back"],
            right: []
          }
        }
      },
      {
        path: "profile/faq",
        name: "ProfileFAQ",
        component: () => import("@/pages/profile/FAQ"),
        meta: {
          auth: true,
          topMenu: {
            left: ["back"],
            right: []
          }
        }
      },
      {
        path: "profile/documents",
        name: "ProfileDocuments",
        component: () => import("@/pages/profile/ProfileDocuments"),
        meta: {
          auth: true,
          topMenu: {
            left: ["back"],
            right: []
          }
        }
      },
      {
        path: "applications",
        name: "Applications",
        component: () => import("@/pages/Bewerbung/Applications"),
        meta: {
          auth: true,
          topMenu: {
            left: ["back"],
            right: ["hamburger", "notification"]
          }
        }
      },
      {
        path: "rejected-applications",
        name: "RejectedApplications",
        component: () => import("@/pages/Bewerbung/RejectedApplications"),
        meta: {
          auth: true,
          topMenu: {
            left: ["back"],
            right: ["hamburger", "notification"]
          }
        }
      },
      {
        path: "selected-application",
        name: "SelectedApplication",
        component: () => import("@/pages/Bewerbung/SelectedApplication"),
        meta: {
          auth: true,
          topMenu: {
            left: ["back"],
            right: ["hamburger", "notification"]
          }
        }
      },
      {
        path: "reject-application",
        name: "RejectApplication",
        component: () => import("@/pages/Bewerbung/RejectApplication"),
        meta: {
          auth: true,
          topMenu: {
            left: ["back"],
            right: ["hamburger", "notification"]
          }
        }
      },
      {
        path: "current-family",
        name: "CurrentFamily",
        component: () => import("@/pages/Bewerbung/CurrentFamily"),
        meta: {
          auth: true,
          topMenu: {
            left: ["back"],
            right: ["hamburger", "notification"]
          }
        }
      },
      {
        path: "selection-other-pk",
        name: "SelectionOtherPK",
        component: () => import("@/pages/Bewerbung/SelectionOtherPK"),
        meta: {
          auth: true,
          topMenu: {
            left: ["back"],
            right: ["hamburger", "notification"]
          }
        }
      },
      {
        path: "waiting",
        name: "ApplicationWaiting",
        component: () => import("@/pages/Bewerbung/ApplicationWaiting"),
        meta: {
          auth: true,
          topMenu: {
            left: ["back"],
            right: ["hamburger", "notification"]
          }
        }
      },
      {
        path: "application-process",
        name: "ApplicationProcess",
        component: () => import("@/pages/Bewerbung/ApplicationProcess"),
        meta: {
          auth: true,
          topMenu: {
            left: ["back"],
            right: ["hamburger", "notification"]
          }
        }
      },
      {
        path: "CallApplication",
        name: "CallApplication",
        component: () => import("@/pages/Bewerbung/CallApplication"),
        meta: {
          auth: true,
          topMenu: {
            left: ["back"],
            right: ["hamburger", "notification"]
          }
        }
      },
      {
        path: "dont-show-family",
        name: "DontShowFamily",
        component: () => import("@/pages/Bewerbung/Dontshowfamily"),
        meta: {
          auth: true,
          topMenu: {
            left: ["back"],
            right: ["hamburger", "notification"]
          }
        }
      },
      {
        path: "request-info",
        name: "RequestInformation",
        component: () => import("@/pages/Neuerfragebogen/RequestInformation"),
        meta: {
          auth: false,
          topMenu: {
            left: ["back"],
            right: []
          }
        }
      },
      {
        path: "invitation/:token",
        name: "VerifyInvitation",
        component: () => import("@/pages/VerifyInvitation"),
        meta: {
          auth: false,
          topMenu: {
            left: [],
            right: []
          }
        }
      },
    ]
  },
  {
    path: "*",
    component: () => import("@/components/cards/PageNotFoundCard")
  }
];
